module.exports = __webpack_public_path__ + "img/3dc-white.e6e2b706.png";